import Vue from 'vue';

const masterAffiliate = [{affiliate_id: '0', label: 'Master Affiliate' }]

export default {
  state: {
    campaigns: [],
    rotators: [],
    affiliateList: masterAffiliate,
    geoList: [],
    vertList: [],
    profileList: []
  },
  mutations: {
    clearUserCache(state) {
      state.campaigns   = []
      state.rotators    = []
      state.geoList     = []
      state.vertList    = []
    },
    campaigns(state, campaigns) {
      state.campaigns = campaigns.map(row => {
        return { ...row, id: row.step1_campaign_id, default: true, category_1: row.vertical, category_2: row.country }
      })
    },
    rotators(state, rotators) {
      state.rotators = rotators.map(row => {
        return { ...row, id: row.id, default: true, category_1: row.vertical, category_2: row.country}
      })
    },
    affiliateList(state, list) {
      state.affiliateList = list || masterAffiliate
    },
    geoList(state, geoList) {
      state.geoList = geoList || []
    },
    vertList(state, vertList) {
      state.vertList = vertList || []
    },
    profileList(state, profileList) {
      state.profileList = profileList || []
    }
  },
  actions: {
    retrieveCampaigns({ state, dispatch, commit, getters }) {
      return new Promise((resolve, reject) => {
        Vue.$http.get(getters.affiliateBaseEndpoint + '/campaigns', { requestId: 'store-cache-retrieve-campaigns', context: Vue._uid})
        .then((response) => resolve(commit('campaigns', response.data.data || [])))
        .catch((error) => {
          if (Vue.$http.isApiError(error))
            commit('campaigns', [])
          reject()
        })
      })
    },
    retrieveRotators({ state, dispatch, commit, getters }) {
      return new Promise((resolve, reject) => {
        Vue.$http.get(getters.affiliateBaseEndpoint + '/rotators', { requestId: 'store-cache-retrieve-rotators', context: Vue._uid})
          .then((response) => resolve(commit('rotators', response.data.data || [])))
          .catch((error) => {
            if (Vue.$http.isApiError(error))
              commit('rotators', [])
            reject()
          })
      })
    },
    searchAffiliates({ state, dispatch, commit }, query) {
      Vue.$http.get(this.getters.baseEndpoint + 'affiliates', {params: {q: query}, requestId: 'store-user-search-affiliate', context: Vue._uid})
        .then((response) => {
          commit('affiliateList', response.data.data.map((item) => {
            return { affiliate_id: item.hitpath_account_id, label: item.name }
          }))
        }).catch((error) => {
          if (Vue.$http.isApiError(error))
            commit('affiliateList', masterAffiliate)
        })
    },
    retrieveGeoList({ commit, dispatch, state }) {
      Vue.$http.get(this.getters.baseEndpoint + 'countries/active', {requestId: 'store-cache-retrieve-geo-list'})
        .then((response) => {
          commit('geoList', response.data.data)
        }).catch((error) => {
          if (Vue.$http.isApiError(error))
            commit('geoList', [])
        })
    },
    retrieveVertList({ commit, dispatch, state }) {
      Vue.$http.get(this.getters.baseEndpoint + 'verticals', {requestId: 'store-cache-retrieve-vert-list'})
        .then((response) => {
          commit('vertList', response.data.data)
        }).catch((error) => {
          if (Vue.$http.isApiError(error))
            commit('vertList', [])
        })
    },
    retrieveProfileList({ commit, dispatch, state }) {
      Vue.$http.get(this.getters.baseEndpoint + 'profiles', {requestId: 'store-cache-retrieve-profile-list'})
        .then((response) => {
          commit('profileList', response.data.data)
        }).catch((error) => {
          if (Vue.$http.isApiError(error))
            commit('profileList', [])
        })
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/cache.js